import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import {
  EntranceTicketType,
  QueryListEntranceTicketTypesForPurchaseArgs,
} from 'apollo/generated/types';
import getApiLanguage from 'i18n/apiLanguage';

const LIST_ENTRANCE_TICKET_TYPES_FOR_PURCHASE = gql`
  query listEntranceTicketTypesForPurchase($date: String!, $language: Language) {
    listEntranceTicketTypesForPurchase(date: $date, language: $language) {
      adultValue
      description
      id
      maxStock
      name
      otherValue
      remaining
      status
      visibility
      entranceImages {
        image
      }
    }
  }
`;

const useListEntranceTicketTypesForPurchaseQuery = (date: string) => {
  const { i18n } = useTranslation();

  return useQuery<
    { listEntranceTicketTypesForPurchase: EntranceTicketType[] },
    QueryListEntranceTicketTypesForPurchaseArgs
  >(LIST_ENTRANCE_TICKET_TYPES_FOR_PURCHASE, {
    variables: { date, language: getApiLanguage(i18n.language) },
  });
};
export default useListEntranceTicketTypesForPurchaseQuery;
